import { toJsonText } from "../../../features/builder.utils";
import { resolverOf } from "./recipient-type.utils";

const isEdit = (formData) => Boolean(formData?.id);

// EntityFormModal fields of a recipient type. Picking the type fills the rest from its resolver's defaults.
export const recipientTypeFields = [
  {
    name: "type_key",
    label: "Recipient type",
    type: "select",
    is_api_data: true,
    optionsKey: "resolvers",
    optionLabelFormatter: (resolver) => `${resolver.name} (${resolver.id})${resolver.recipient_type_fid ? " · already set up" : ""}`,
    required: true,
    isReadOnly: isEdit,
    onValueChange: (value, formData, dependencies) => {
      const resolver = resolverOf({ type_key: value }, dependencies);
      if (!resolver) return {};
      return {
        name: resolver.name,
        description: resolver.description || "",
        needs_subject: resolver.needs_subject === true,
        allowed_triggers: resolver.allowed_triggers ?? [],
        config_schema_text: toJsonText(resolver.config_schema),
      };
    },
  },
  { name: "name", label: "Name", required: true, maxLength: 100 },
  {
    name: "allowed_triggers",
    label: "Trigger types (empty = all)",
    type: "select",
    isMulti: true,
    is_api_data: true,
    optionsKey: "triggerTypes",
    optionLabel: "label",
  },
  { name: "sort_order", label: "Sort order", type: "number", min: 0, max: 10000 },
  {
    name: "needs_subject",
    label: "Needs the subject",
    type: "boolean",
    isReadOnly: (formData, dependencies) => resolverOf(formData, dependencies)?.needs_subject === true,
    hint: (formData, dependencies) =>
      resolverOf(formData, dependencies)?.needs_subject === true ? "Resolved from the user the case is about, so it always needs one." : "On: only offered for sources whose rows are about a user.",
  },
  { name: "is_activated", label: "Active", type: "boolean", defaultValue: true, editValue: (record) => record.is_activated === true },
  { name: "description", label: "Description", type: "textarea", fullWidth: true, rows: 2, maxLength: 500 },
  {
    name: "edit_schema",
    label: "Edit config schema as JSON",
    type: "boolean",
    editValue: () => false,
    hint: "The config schema is what a rule step asks for (e.g. the role). Off keeps the resolver's default on a new type, and the saved one on an edit.",
  },
  {
    name: "config_schema_text",
    label: "Config schema",
    type: "textarea",
    fullWidth: true,
    rows: 7,
    hidden: (formData) => !formData.edit_schema,
    editValue: (record) => toJsonText(record.config_schema),
  },
];
